export default "__VITE_ASSET__B6B3uhj2__"